import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgEms({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.011 9.849L2.5 9.25h6.094l-.163.599H3.01zm.817.957l-.512-.598h5.022l-.163.598H3.828zm.299.36l.511.598h3.276l.163-.599h-3.95zm1.328 1.55l-.512-.598h2.878l-.163.598H5.455zm.304.36l.512.598h1.131l.164-.599H5.759zm1.371 1.61l-.555-.653h.73l-.175.653z"
        fill="#FF8400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.015 9.861l.165-.611H9.427l-1.448 5.381h2.753l.095-.354c.095-.356.19-.712.275-1.022H9.846l.174-.659h1.257c.152-.576.277-1.039.353-1.311h-1.257l.175-.658h1.262c.046-.178.126-.475.205-.766zm9.137 1.005l.256-.958-.767-.658h-1.545l-.985.658-.555 2.063.598.566h1.165l-.207.777h-.539l.082-.299h-1.377l-.256.936.768.68h1.6l.984-.658.55-2.046-.751-.647h-.99l.19-.719h.479l-.082.3 1.382.005zm-4.908 3.765l1.448-5.381H15.89l-1.22 2.264.012-2.264h-1.785l-1.442 5.381h1.377l.821-3.069-.12 3.07h.588c.181-.354.486-.956.79-1.557.308-.61.616-1.219.794-1.567l-.838 3.123h1.376z"
        fill="#0033A1"
      />
    </svg>
  )
}

export default SvgEms
